import { createContext } from "react";
import { StoreApi } from "zustand";

import { ActivityFormStoreType } from "./activity_form_store.types";

type ActivityFormStoreContextType = StoreApi<ActivityFormStoreType>;

export const ActivityFormStoreContext = createContext<ActivityFormStoreContextType>(
  {} as ActivityFormStoreContextType
);
